import usePlausible from 'hooks/usePlausible'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import UAParser from 'ua-parser-js'
import useKeyboardShortcut from 'use-keyboard-shortcut'

import {
  selectCurrentHotelId,
  selectHotelList,
  selectIsInternalAdmin
} from '../../../accessors/index'
import {
  generateShortNameAndBrand,
  logoutUser,
  postAndSelectSubsidiary
} from '../../../actions/index'
import HotelSwitcher from '../../../features/Welcome/HotelSwitcher/index'
import SiteIcon from '../SiteIcon/index'
import styles from './CurrentHotelWithSelector.module.scss'

const CurrentHotelWithSelector = ({ isMobileMenuOpen, wrapperStyle = {} }) => {
  const dispatch = useDispatch()

  const currentUser = useSelector(s => s.login.currentUser)
  const isInternalAdmin = useSelector(selectIsInternalAdmin)
  const [showHotelSwitcher, setShowHotelSwitcher] = useState()

  const { postEvent, plausibleEvents } = usePlausible()

  const isDemoMode = useSelector(s => s.login.isDemoMode)

  const os = new UAParser().getOS().name

  useKeyboardShortcut([os === 'Mac OS' ? 'Meta' : 'Control', 'J'], () =>
    setShowHotelSwitcher(!showHotelSwitcher)
  )

  function logOut() {
    postEvent(plausibleEvents.LogOut)
    dispatch(logoutUser())

    sessionStorage.clear() // to clear microsoft login session
  }

  useEffect(() => {
    function handleClickOutside(e) {
      if (selectorRef) {
        if (selectorRef.current.contains(e.target)) {
          if (!showHotelSwitcher) {
            setShowHotelSwitcher(true)
          }
        } else {
          setShowHotelSwitcher(false)
        }
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [showHotelSwitcher])

  const selectorRef = useRef()

  const currentHotel = useSelector(s => s.hotelDetails)

  if (!currentHotel) {
    return null
  }

  const {
    name: subsidiaryName,
    primaryWebsiteUrl: websiteAddress,
    displayId
  } = currentHotel || {}

  const { brand, shortName } = generateShortNameAndBrand(subsidiaryName)

  return (
    <nav
      className={[
        styles.wrapper,
        isMobileMenuOpen ? styles.mobileMenuOpen : styles.mobileMenuClosed
      ].join(' ')}
      style={wrapperStyle}
      ref={selectorRef}
    >
      <div className={styles.container}>
        <button className={styles.navlink} title="Click to change hotel">
          {isDemoMode ? (
            <div className={styles.usernameGroup}>
              <div className={styles.hotelname}>
                <SiteIcon url="https://directful.com" />
                <span className={styles.hotelShortName}>Directful Demo</span>
              </div>
            </div>
          ) : (
            <div className={styles.usernameGroup}>
              {brand ? (
                <div className={styles.neatHotelName}>
                  <div className={styles.hotelBrand}>
                    <SiteIcon url={websiteAddress} />
                    <span>{brand} </span>
                  </div>
                  <div className={styles.hotelShortName}>
                    {isInternalAdmin && (
                      <span className={styles.displayId}>{displayId}</span>
                    )}
                    {shortName}
                  </div>
                </div>
              ) : (
                <div className={styles.hotelname}>
                  <SiteIcon url={websiteAddress} />
                  {isInternalAdmin && (
                    <span className={styles.displayId}>{displayId}</span>
                  )}
                  <span className={styles.hotelShortName}>
                    {subsidiaryName && subsidiaryName.length > 44
                      ? subsidiaryName.substring(0, 44) + '...'
                      : subsidiaryName}
                  </span>
                </div>
              )}
            </div>
          )}
        </button>
      </div>
      {showHotelSwitcher && (
        <div className="header-nav-inner">
          {currentUser && (
            <HotelSwitcher>
              <li className={styles.logout}>
                <button onClick={logOut}>Log out {currentUser?.name}</button>
              </li>
            </HotelSwitcher>
          )}
        </div>
      )}
    </nav>
  )
}

export default CurrentHotelWithSelector
